import React, { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

const MAX_MOTIVO_CANCELAMENTO = 255;

// Motivo do cancelamento da NFS-e. onConfirmar(motivo) deve retornar true quando o cancelamento for aceito.
export default function ModalMotivoCancelamentoNfse({ open, nota, loading, onClose, onConfirmar }) {
    const [motivo, setMotivo] = useState("");

    const fechar = () => {
        if (loading) return;
        setMotivo("");
        onClose();
    };

    const confirmar = async () => {
        if (!motivo.trim()) return alert("Informe o motivo do cancelamento.");
        if (await onConfirmar(motivo.trim())) setMotivo("");
    };

    return (
        <Dialog open={open} onClose={fechar} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontSize: 17, fontWeight: 600 }}>
                Cancelar nota{nota?.numero ? ` nº ${nota.numero}` : nota?.idNota ? ` #${nota.idNota}` : ""}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Informe o motivo do cancelamento. Ele será enviado à prefeitura junto com a solicitação.
                </Typography>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    O cancelamento não pode ser desfeito.
                </Alert>
                <TextField
                    autoFocus
                    required
                    fullWidth
                    multiline
                    minRows={3}
                    label="Motivo do cancelamento"
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value.slice(0, MAX_MOTIVO_CANCELAMENTO))}
                    helperText={`${motivo.length}/${MAX_MOTIVO_CANCELAMENTO}`}
                />
            </DialogContent>
            <DialogActions>
                <Button size="small" sx={{ textTransform: "none" }} disabled={loading} onClick={fechar}>
                    Voltar
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="error"
                    sx={{ textTransform: "none" }}
                    disabled={!motivo.trim()}
                    loading={loading}
                    onClick={confirmar}
                >
                    Cancelar nota
                </Button>
            </DialogActions>
        </Dialog>
    );
}
